import { filter } from 'rxjs/internal/operators/filter';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';

export function distinctUntilUserChanged() {
	return <T>(source: Observable<T>): Observable<T> => {
		return source.pipe(
			filter(user => !!user),
			distinctUntilChanged((a: any, b: any) => a.id === b.id)
		);
	};
}

export function filterIsKeyEnter() {
	return (source: Observable<KeyboardEvent>): Observable<KeyboardEvent> => {
		return source.pipe(
			filter((ev: KeyboardEvent) => {
				// tslint:disable-next-line
				const key = ev.which || ev.keyCode;
				return key === 13;
			})
		);
	};
}
export function filterIsNotKeyEnter() {
	return (source: Observable<KeyboardEvent>): Observable<KeyboardEvent> => {
		return source.pipe(
			filter((ev: KeyboardEvent) => {
				// tslint:disable-next-line
				const key = ev.which || ev.keyCode;
				return key !== 13;
			})
		);
	};
}
